import { success, custom, failure } from "./utilities.js";
import { orderService } from "../../services";
import { orderConstants, globalConstants } from "../../constants";

export const getOrderById = (orderId) => {
    return (dispatch) => {
        orderService
            .getOrderById(orderId)
            .then((response) =>
                dispatch(success(response, orderConstants.GET_ORDERS))
            )
            .catch((error) => {
                console.error(error);
            });
    };
}

export const getOrdersWithParams = ({limit,page,status_id, sort}) => {
    return (dispatch) => {
        orderService
            .getOrdersWithParams(limit,page,status_id,sort)
            .then((response) =>
                dispatch(success(response, orderConstants.GET_ORDERS))
            )
            .catch((error) => {
                console.error(error);
            });
    };
}

export const getOrderStatusesWithCount = () => {
    return (dispatch) => {
        orderService
            .getOrderStatusesWithCount()
            .then((response) =>
                dispatch(success(response, orderConstants.GET_ORDER_STATUSES))
            )
            .catch((error) => {
                console.error(error);
            });
    };
}

export const orderActions = { getOrderById, getOrdersWithParams, getOrderStatusesWithCount }